var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause-circle",
    clipPath: "url(#clip0_4027_18341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.70801 13.7497V8.24967M13.2913 13.7497V8.24967M20.1663 10.9997C20.1663 16.0623 16.0623 20.1663 10.9997 20.1663C5.93706 20.1663 1.83301 16.0623 1.83301 10.9997C1.83301 5.93706 5.93706 1.83301 10.9997 1.83301C16.0623 1.83301 20.1663 5.93706 20.1663 10.9997Z",
    stroke: "#3E9BE4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4027_18341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircle);
export default __webpack_public_path__ + "static/media/pause-circle.4c9808d70fec175d4cf2cf6bc72663c2.svg";
export { ForwardRef as ReactComponent };